import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import FareRuleDetail from './FareRuleDetail';
import * as fareRuleActions from './../../../../../actions/fareRuleAction';

const mapStateToProps = state => {
    return {
        fareRuleState: state.fareRuleReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getFareRuleDetail: (id) => dispatch(fareRuleActions.getFareRuleDetail(id)),
        setFareRuleDetail: (fareRule) => dispatch(fareRuleActions.setFareRuleDetail(fareRule)),
        updateFareRuleDetail: (fareRule) => dispatch(fareRuleActions.updateFareRuleDetail(fareRule)),
        createFareRuleDetail: (fareRule) => dispatch(fareRuleActions.createFareRuleDetail(fareRule)),
        createFareRuleTranslate: (fareRule, language) => dispatch(fareRuleActions.createFareRuleTranslate(fareRule, language)),
        updateFareRuleTranslate: (fareRule, language) => dispatch(fareRuleActions.updateFareRuleTranslate(fareRule, language)),
        deleteFareRuleTranslate: (fareRule, refreshParams) => dispatch(fareRuleActions.deleteFareRuleTranslate(fareRule, refreshParams)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(FareRuleDetail));
